<template>
    <div class="mb-4 ml-[0.5rem]">
        <h4 class="font-roboto mobile:text-[16px] tablet:text-[20px] m-0 text-red-500">
{{ plan.months + ' months plan'
            }}
</h4>
        <h2 v-if="plan.is_show_amount == 1" class="font-roboto mobile:text-[30px] tablet:text-[40px] font-bold text-gray-900">
${{
            $helper.formatAmount(plan.amount) }}<span class="text-xl">/mo</span>
</h2>
    </div>
    <div class="py-1 ml-[0.5rem]">
        <div class="w-full h-auto m-0 planDescription" v-html="plan.description" />
    </div>
    <customAccordion :items="accordionData" />
    <div
v-if="plan.terms_and_conditions && plan.terms_and_conditions.length > 0"
        class="ml-[0.5rem] my-[0.7rem] group rounded-[10px] border-[1px] transition duration-300 border-[#A084E8] hover:bg-[#A084E8] [@media(max-width:1023px)]:!bg-[#A084E8]"
>
        <a
:href="plan.terms_and_conditions" target="_blank" rel="noopener" class="block no-underline text-center text-[16px] font-roboto font-medium px-1 py-1.5 cursor-pointer text-[#9336B4] group-hover:text-white [@media(max-width:1023px)]:!text-white transition duration-300 
            "
>Terms & Conditions</a>
    </div>
</template>


<script>
import customAccordion from '../partialComponent/customAccordion.vue';
export default {
    components: {
        customAccordion,
    },
    props: {
        plan: Object,
        isSelected: Boolean,
    },

    data() {
        return {
        };
    },

    computed: {
        accordionData() {
            let arr = []

            if (this.plan.covered && this.plan.covered.length > 0) {
                arr.push({
                    title: "What's covered:",
                    content: this.plan.covered,
                    class: 'planDescription'
                })
            }

            if (this.plan.unit_quantity && this.plan.unit_quantity.length > 0) {
                arr.push({
                    title: "Unit quantity: Why do I need more?",
                    content: this.plan.unit_quantity,
                    class: 'planDescription'
                })
            }

            if (this.plan.not_covered && this.plan.not_covered.length > 0) {
                arr.push({
                    title: "What's not covered:",
                    content: this.plan.not_covered,
                    class: 'planDescription'
                })
            }

            if (this.plan.limitations && this.plan.limitations.length > 0) {
                arr.push({
                    title: "Limitations:",
                    content: this.plan.limitations,
                    class: 'planDescription'
                })
            }
            return arr
        }
    },
}
</script>
